<!--
 * @Descripttion: 
 * @Author: zcy
 * @Date: 2021-12-22 16:25:52
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2022-10-25 13:51:21
-->
<template>
  <div class="contactus">
    <!-- 主题内容盒子 -->
    <div class="contactus-main">
      <div class="contactus-title">{{ title }}</div>
      <div class="contactus-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "contactus",
  props: {
    title: String,
  },
};
</script>
<style lang="less" scoped>
.contactus {
  width: 100%;
  height: 100%;
  position: relative;

  .contactus-main {
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 116rem;
    height: 63rem;
    transform: translate(-50%, -50%);

    .contactus-title {
      white-space: nowrap;
      padding-top: 0.6rem;
      box-sizing: border-box;
      width: 35rem;
      text-align: center;
      margin: 0 auto;
      font-size: 1.74rem;
      //font-family: Alibaba PuHuiTi;
      font-family: Alibaba-PuHuiTi-Medium;
      font-weight: 500;
      color: #2b2b2b;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .contactus-content {
      box-sizing: border-box;
      width: 100%;
      height: 60.6rem;
    }
  }

  /*滚动条整体样式*/
  ::-webkit-scrollbar {
    width: 1.17rem;
    // height: 4px;
  }
  /*滚动条里面小方块*/
  ::-webkit-scrollbar-thumb {
    background: #929292;
    border-radius: 0.5rem;
    height: 0.5rem;
  }
  // /*滚动条里面轨道*/
  ::-webkit-scrollbar-track {
    background: #d9d9d9;
    border-radius: 20rem;
  }
}
</style>
